import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Users, ShoppingBag, Timer, ChatCircleDots, Phone, CurrencyDollar, ArrowsLeftRight, PhoneSlash } from "@phosphor-icons/react";
import TurnRecommendationCard from "../components/TurnRecommendationCard";

const Stat = ({ label, value, icon, testid }) => (
  <div className="paper-card p-6" data-testid={testid}>
    <div className="flex items-center gap-3 mb-2">
      <div className="w-9 h-9 rounded-lg bg-[#E6E2D6] flex items-center justify-center">{icon}</div>
      <div className="overline">{label}</div>
    </div>
    <div className="text-3xl font-heading font-extrabold">{value}</div>
  </div>
);

export default function DashAnalytics() {
  const [a, setA] = useState(null);
  useEffect(() => { api.get("/analytics").then((r) => setA(r.data)); }, []);
  if (!a) return <div>Loading…</div>;
  const noShowRate = a.guests_total > 0 ? Math.round((a.guests_no_show / a.guests_total) * 100) : 0;
  const v = a.voice || { period_days: 30, calls_total: 0, ai_handled: 0, ai_handled_pct: 0, transferred: 0, transferred_pct: 0, missed: 0, missed_pct: 0, avg_duration_seconds: 0, ai_minutes: 0, dollars_saved: 0 };
  const mmss = (s) => `${Math.floor(s/60)}:${String(s%60).padStart(2,"0")}`;

  return (
    <div>
      <div className="overline">Insights</div>
      <h1 className="text-3xl mb-8">Analytics</h1>
      <TurnRecommendationCard />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
        <Stat label="Total guests" value={a.guests_total} icon={<Users size={18} color="#1E3A2F" />} />
        <Stat label="Currently waiting" value={a.guests_waiting} icon={<Timer size={18} color="#D96C5B" />} />
        <Stat label="Seated" value={a.guests_seated} icon={<Users size={18} color="#1E3A2F" />} />
        <Stat label="No-show rate" value={`${noShowRate}%`} icon={<Users size={18} color="#A5382A" />} />
        <Stat label="Orders" value={a.orders_total} icon={<ShoppingBag size={18} color="#1E3A2F" />} />
        <Stat label="Revenue" value={`$${a.revenue.toFixed(2)}`} icon={<ShoppingBag size={18} color="#1E3A2F" />} />
        <Stat label="AI chats" value={a.ai_chats} icon={<ChatCircleDots size={18} color="#1E3A2F" />} />
        <Stat label="Avg wait" value={`${a.avg_wait_minutes}m`} icon={<Timer size={18} color="#1E3A2F" />} />
      </div>

      {/* Voice ROI */}
      <div className="mt-10" data-testid="voice-roi">
        <div className="flex items-baseline gap-3 mb-4 flex-wrap">
          <div className="overline">Voice ROI</div>
          <span className="text-xs text-[#5C6B61]">last {v.period_days} days · $0.30/min saved vs. a live receptionist</span>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          <Stat testid="voice-roi-dollars" label="Est. saved" value={`$${v.dollars_saved.toFixed(2)}`} icon={<CurrencyDollar size={18} color="#1E3A2F" weight="fill" />} />
          <Stat testid="voice-roi-calls" label="Calls" value={v.calls_total} icon={<Phone size={18} color="#1E3A2F" />} />
          <Stat testid="voice-roi-ai" label="AI-handled" value={`${v.ai_handled_pct}%`} icon={<Phone size={18} color="#D96C5B" weight="fill" />} />
          <Stat testid="voice-roi-avg-duration" label="Avg call" value={mmss(v.avg_duration_seconds)} icon={<Timer size={18} color="#1E3A2F" />} />
          <Stat testid="voice-roi-transferred" label="Transferred" value={`${v.transferred_pct}%`} icon={<ArrowsLeftRight size={18} color="#1E3A2F" />} />
          <Stat testid="voice-roi-missed" label="Missed" value={`${v.missed_pct}%`} icon={<PhoneSlash size={18} color="#A5382A" />} />
          <Stat testid="voice-roi-ai-minutes" label="AI minutes" value={v.ai_minutes} icon={<Timer size={18} color="#1E3A2F" />} />
        </div>
        {v.calls_total === 0 && (
          <p className="text-xs text-[#5C6B61] mt-4">No calls in the last {v.period_days} days. Once your Twilio number rings the AI receptionist, this panel will show live ROI numbers.</p>
        )}
      </div>
    </div>
  );
}
